/* eslint-disable */
export default {
  status: 'Status',
  acceptQueueCalls: 'Wachtrij-oproepen accepteren',
  callQueueDisabledReason:
    'Deze instelling wordt beheerd door uw bedrijfsbeheerder.',
  callQueueManagement: 'Wachtrijen beheren',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
